<template>
    <div class="main">
      <tab title='编辑'></tab>
      <div class="input_box">
          <van-cell-group>
                <van-field v-model="item.cardNo" type="text" :disabled="disabled" label="卡号" />
                <van-field v-model="item.custName" type="text" maxlength="8" placeholder="请输入姓名" label="姓名" />
                <van-field v-model="item.carLimit" type="text"maxlength="20"  placeholder="请输入车牌号" label="车牌号" inputmode="none" @click-input="showKeyboard"  @click="showKeyboard"
                />
                <van-field v-model="item.password" type="number" maxlength="6" placeholder="请输入密码" label="密码" />
          </van-cell-group>
          
      </div>
      <div class="confirm_btn" @click="updPassword">确认</div>
      <vnp-keyboard v-model="item.carLimit" v-if="show" :show.sync="show"></vnp-keyboard>
    </div>
  </template>
  
  <script>
  import tab from '@/components/NavBar'
  import Keyboard from '@/components/vant-number-plate/vnp-keyboard';
import VnpInput from '@/components/vant-number-plate/vnp-input';
  import Vue from 'vue';
  import { Field } from 'vant';
  import { Toast } from 'vant';
  import { Dialog } from 'vant';
  
  Vue.use(Toast);
  Vue.use(Field);
  
  export default {
    name: 'margin',
    data () {
      return {
        item:'',
        disabled:true,

        show: false,
        value1: '',
      }
    },
    components:{
        'tab':tab,
        'vnp-keyboard': Keyboard,
        'vnp-input': VnpInput
    },
    mounted(){
        this.item = this.$route.params.item
        console.log(this.item)
    },
    methods:{
      showKeyboard(){
        console.log(123)

        this.show = true
        console.log(this.show)
      },
      updPassword(){
        if(this.item.custName ==''||this.item.carLimit ==''||this.item.password ==''){
          Toast('请输入完整后保存');
          return
        }
        Toast.loading({
          message: '加载中...',
          forbidClick: true
        });
        var data = {
          password:this.item.password,
          custName:this.item.custName,
          carLimit:this.item.carLimit,
          id:this.item.id,
          token:this.$storage.get('token')
        }
        this.$api.post('orgapp/updateCustCard',data,res=>{
          if (res.status >= 200 && res.status < 300) {
            var data = res.data
            Toast.clear();
            if(data.msg=="success"){
              Dialog.alert({
                title: '温馨提示',
                message: '修改成功',
              }).then(() => {
                // on close
                this.$router.go(-1);
              });
            }else{
              Toast.clear();
              Toast.fail(data.msg);
            }
          }else{
            Toast.clear();
            Toast.fail(res.status);
          }
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .main {
      height: 100vh;
      background-color: #F7F8FA;
  }
  .input_box {
      margin-top: 30px;
  }
  .confirm_btn {
      width: 70%;
      height: 40px;
      margin: auto;
      margin-top: 20px;
      background-color: #1989FA;
      text-align: center;
      line-height: 40px;
      color: #fff;
      border-radius: 5px;
      /* animation: myAnimation 5s infinite; */
  }
  /* @keyframes myAnimation{
    0%{
      transform: scale(1)
    }
    25%{
      transform: scale(1.2)
    }
    50%{
      transform: scale(1)
    }
    75%{
      transform: scale(1.2)
    }
  } */
  </style>
  


// WEBPACK FOOTER //
// src/components/updCard_info.vue